import RightIcon from '@mui/icons-material/ChevronRight'

const Icon = () => {
  return (
    <RightIcon
      htmlColor='rgba(0, 0, 0, 0.54)'
      fontSize='medium'
    />
  )
}

export default Icon
